import {HttpResponse} from "@angular/common/http";

export default class Utils {
    static downloadFileContent(response: HttpResponse<Blob>, unescapeFileName?) {
        const contentDispositionHeader = response.headers.get("Content-Disposition");
        let filename = "";
        if (unescapeFileName) {
            filename = unescape(contentDispositionHeader.split(";")[1].trim().split("=")[1]);
        } else {
            filename = contentDispositionHeader.split(";")[1].trim().split("=")[1];
        }
        const file = new Blob([response.body], {
            type: "application/octet-stream"
        });
        const link = window.document.createElement("a");
        link.href = window.URL.createObjectURL(file);
        link.download = filename.replace(/"/g, "");
        link.click();
        URL.revokeObjectURL(link.href);
    }

    // Formats a date.
    static FormatDate = date => {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        const ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? "0" + minutes : minutes;
        const strTime = hours + ":" + minutes + " " + ampm;
        return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + " " + strTime;
    };

    // copies a selection to the clipboard
    static CopyText = (text: string) => {
        navigator.clipboard
            .writeText(text)
            .then()
            .catch(e => console.log(e));
    };
}
